import { DevApi, handleApiError } from "./AxiosObjects";

export async function CheckAccessControl(setaccessPermission) {
  try {
    const response = await DevApi.get("EDM-Dev-Tableau-Access-Control");
    setaccessPermission(response.data.permission);
  } catch (error) {
    const apiError = handleApiError(error);
    console.error('[Access Control Check Error]:', apiError.message);
    setaccessPermission(false);
  }
}

export async function FetchAccessableTableau(
  setData,
  setAccess,
  setloading,
  dataSource
) {
  if (!["tableau", "tableau_datasource"].includes(dataSource)) {
    console.error("[Fetch Accessible Tableau Error]: Invalid data source");
    setloading(false);
    return;
  }

  try {
    setloading(true);
    const response = await DevApi.get(
      `EDM-Dev-Tableau-Workbooks-Access-Load?source=${encodeURIComponent(dataSource)}`
    );

    const data = response.data.data;
    setData(data);

    const access = {};
    if (dataSource === "tableau") {
      data.forEach((item) => (access[item[2]] = item[5]));
    } else if (dataSource === "tableau_datasource") {
      data.forEach((item) => (access[item[2]] = item[3]));
    }
    setAccess(access);
    setloading(false);
  } catch (error) {
    const apiError = handleApiError(error);
    console.error('[Fetch Accessible Tableau Error]:', apiError.message);
    setloading(false);
  }
}

export async function FetchAccessableDashboards(
  setudwdata,
  setudwAccess,
  setloading,
  getUniqueKey
) {
  try {
    setloading(true);
    const response = await DevApi.get("EDM-Dev-Tableau-Workbooks-Access-Load?source=obiee");

    setudwdata(response.data.data);
    const udwAccess = {};
    response.data.data.forEach((item) => {
      udwAccess[getUniqueKey(item)] = item[3];
    });
    setudwAccess(udwAccess);
    setloading(false);
  } catch (error) {
    const apiError = handleApiError(error);
    console.error('[Fetch Accessible Dashboards Error]:', apiError.message);
    setloading(false);
  }
}

export async function FetchAccessableDV(
  setdvData,
  setdvAccess,
  setSchemas,
  setloading
) {
  try {
    setloading(true);
    const response = await DevApi.get("EDM-Dev-Tableau-Workbooks-Access-Load?source=dv");

    setdvData(response.data.data);
    const dvAccess = {};

    const schemaSet = new Set(response.data.data.map((item) => item[1]));
    setSchemas(Array.from(schemaSet));

    response.data.data.forEach((item) => (dvAccess[item[0]] = item[9]));
    setdvAccess(dvAccess);
    setloading(false);
  } catch (error) {
    const apiError = handleApiError(error);
    console.error('[Fetch Accessible DV Error]:', apiError.message);
    setloading(false);
  }
}

export async function ModifyAccessToWorkbooks(
  restrict_list,
  delete_list,
  source
) {
  try {
    if (restrict_list.length) {
      await DevApi.post(
        `EDM-Dev-Tableau-Access-Control?action=r&source=${encodeURIComponent(source)}`,
        { report_ids: restrict_list }
      );
    }

    if (delete_list.length) {
      await DevApi.post(
        `EDM-Dev-Tableau-Access-Control?action=d&source=${encodeURIComponent(source)}`,
        { report_ids: delete_list }
      );
    }
  } catch (error) {
    const apiError = handleApiError(error);
    console.error('[Modify Access Error]:', apiError.message);
    throw apiError;
  }
}
